import Vue from 'vue';
import Router from 'vue-router';
import create from './create';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: create()
});

router.beforeEach(async (to, form, next) => {

  next();

  let tasks = [];

  router.getMatchedComponents(to.path).forEach(async c => {
    tasks = tasks.concat(c.tasks);
  });

  try {
    window.vm_screen_loading = true;
    for (let i = 0; i < tasks.length; i++) {
      const task = tasks[i];
      if (task instanceof Array) {
        await Promise.all(task.map(a => a.handle()));
      } else {
        await task.handle();
      }
    }
    window.vm_screen_loading = false;
  } catch (e) {
    window.vm_screen_loading = false;
    console.error('发生错误' + e.toString());
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js